import Vue from "vue"
const base = {
  computed: {
    wmHeight() {
      return document.body.clientHeight
    }
  }
}

Vue.mixin(base)

